import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1100px;
  margin: 20px auto;

  footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px 45px;
  }
`;

export const PageOptions = styled.div`
  display: flex;
  align-items: center;

  span.page-option {
    margin: 0 6px;
  }

  [class*='-container'] {
    margin: 0 6px;

    [class*='-control'] {
      max-height: 34px;

      > div {
        margin-bottom: 0;
      }
    }
    [class*='-indicatorContainer'] {
      padding: 3px;
    }
  }
`;

export const TableStyled = styled.table`
  width: 100%;
  padding: 50px;

  background: ${({ theme }) => theme.colors.shape};
  border: 1px solid ${({ theme }) => theme.colors.line};
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.32);
  border-radius: 4px;

  th {
    text-align: left;
    padding: 28px 8px;
    font-size: 10px;
    color: ${({ theme }) => theme.colors.textLight};

    > div {
      display: flex;
    }
  }

  tbody tr {
    max-height: 56px;
    td {
      padding: 10px 8px;
      font-size: 14px;
      line-height: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      align-self: center;
    }

    &:nth-child(odd) {
      background-color: ${({ theme }) => theme.colors.background};

      td:first-child {
        border-radius: 4px 0 0 4px;
      }

      td:last-child {
        border-radius: 0 4px 4px 0;
      }
    }
  }
`;

export const IconContainer = styled.span`
  display: inline-flex;
  flex-direction: column;
  margin-left: 6px;
`;
